export enum GridColumnsUserSettingEnum {
	Visibility = 'visibility',
}
